import { ReadOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useNavigate } from "react-router-dom";

import { useManualIndex } from "./manualHooks";
import { sectionFor } from "./screen";

export function ManualButton() {
  const index = useManualIndex();
  const navigate = useNavigate();
  // パスは押した時点のものを読む。react-router は遷移の描画を遅らせる(startTransition)ので、
  // useLocation の値だとログイン直後の戻り先への移動などで 1 つ前の画面を引くことがある。
  const open = () => {
    const hit = sectionFor(index.data, window.location.pathname);
    navigate(hit ? `/manual/${hit.module}#${encodeURIComponent(hit.anchor)}` : "/manual");
  };
  return (
    <Tooltip title="マニュアル">
      <button type="button" className="ux-iconbtn" aria-label="マニュアル"
        aria-busy={!index.data && !index.isError} onClick={open}>
        <ReadOutlined />
      </button>
    </Tooltip>
  );
}
